<template>
  <div class="overflow-hidden container-fluid" style="box-sizing: border-box">
    <RouterView />
  </div>
</template>

<style lang="scss">
@import '@/assets/stylesheets/Sass/all.scss';
</style>
